import { AREngineForIOS } from '../scene-builder';
import { forceIOSImplementationOnAndroid } from '../../main';

export type XrFramework = 'webxr' | '8th-wall' | 'zapworks' | 'needle';

export type DeviceType = 'android' | 'ios' | 'desktop';

export function getDeviceType(): DeviceType {
  const ua = navigator.userAgent || navigator.vendor || '';
  if (/Android/i.test(ua)) return 'android';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  return 'desktop';
}

export async function isWebXRARSupported() {
  const devOverride =
    typeof URLSearchParams !== 'undefined' &&
    new URLSearchParams(window.location.search).get('webxr') === '1';
  if (devOverride || (typeof localStorage !== 'undefined' && localStorage.getItem('forceWebXR') === '1')) {
    return true;
  }
  if (!navigator.xr) return false;
  try {
    return await navigator.xr.isSessionSupported('immersive-ar');
  } catch {
    return false;
  }
}

export async function getXRFrameworkToUse(device: DeviceType): Promise<XrFramework> {
  switch (device) {
    case 'android':
      if (await isWebXRARSupported()) {
        if (forceIOSImplementationOnAndroid) {
          return AREngineForIOS;
        }
        return 'webxr';
      }
      return AREngineForIOS;
    case 'ios':
      return AREngineForIOS;
    default:
      return AREngineForIOS;
  }
}
